export const CONSTRUCTION_AI_MODEL_NAME = "BidKid";
export const CONSTRUCTION_AI_MODEL_VERSION = "1";

export const LEARNING_COUNTER_STORAGE_KEY = `boon_learning_counters_v${CONSTRUCTION_AI_MODEL_VERSION}`;
export const SKIP_LEARNING_POPUP_STORAGE_KEY = "boon_skip_first_learning_popup";
